<div class="gen-tbl-header-top">
	<h4
		class="gen-title"
		titleLang="followups"
	>
		{{ "mixed_list" | langVal }}
	</h4>
	<div class="gen-tbl-search actual-search">
		<app-gen-input
			[actualObj]="this"
			fieldName="searchStr"
			(keyupEvent)="search()"
			title_ph_lang="search"
			[addonObject]="{ after: { icon: 'search' } }"
			tabindex="-1"
		>
		</app-gen-input>
	</div>
</div>
<div class="align-items-center d-flex gap-3 pb-2">
	<div class="d-flex flex-nowrap">
		@if (currentPeriod != "all_options") {
			<div class="colstat colstat-price">
				<label>{{ "from_date" | langVal }}</label>
				<app-date-picker
					#fromDate
					[actualObj]="this"
					fieldName="date_from"
					(changeEvent)="currentPeriod = 'date_range'; search()"
				/>
			</div>

			<div class="colstat-price">
				<label>{{ "to_date" | langVal }}</label>
				<app-date-picker
					#toDate
					[actualObj]="this"
					fieldName="date_to"
					(changeEvent)="currentPeriod = 'date_range'; search()"
				/>
			</div>
		}
	</div>
	<div>
		<label>{{ "period" | langVal }}</label>
		<br />
		<app-gen-button-group
			[actualObj]="this"
			fieldName="currentPeriod"
			[options]="periodInputs"
			title_ph_lang="period"
			(changeEvent)="chPeriod()"
		/>
	</div>
</div>
<div class="sorter">
	<th
		(click)="sort('date')"
		sorter
		fieldName="date"
		[displayName]="'date' | langVal"
		[sortField]="sortField"
		[sortIsAsc]="sortIsAsc"
		class="card-date"
	></th>
	<!-- <th>{{ "meetingtype" | langVal }}</th>
		<th>{{ "arrived" | langVal }}</th>
		@if (
			permsService?.perms?.clinic_financial ||
			permsService?.perms?.administrative
		) {
			<th>{{ "price_patient" | langVal }}</th>
		}

		@if (permsService.owner_has_users) {
			<th>{{ "assoc" | langVal }}</th>
		} -->
</div>

<div id="section-to-print-mixed-list">
	<div class="cards-list">
		@for (row of objectCollectionShown; track row) {
			<div class="card-container">
				<div
					class="card-wrapper"
					(click)="openRow(row)"
					[class.pointer]="row?.type == 'followup' && row.id != followup_id"
				>
					<div
						class="card-date"
						[spinner]="$safeNavigationMigration(row?.isFetching)"
					>
						<b>
							{{ row.date | dateFormat }}
							{{ row.date_to ? " - " + (row.date_to | dateFormat) : "" }}
						</b>
						@if (!row.date_to) {
							<span>{{ store.timeNoSeconds(row.time) }}</span>
						}
					</div>
					@if (row?.meetingtype_name) {
						<div class="card-title d-flex gap-1">
							<span>{{ "meetingtype" | langVal }}: </span>

							<b>{{ row.meetingtype_name }}</b>
						</div>
					}
					@if (row?.diagOrMedic) {
						@switch (row.type) {
							@case ("testfill") {
								<span>{{ "test" | langVal }}: </span>
							}
							@case ("diagppatient") {
								<span>{{ "diagp" | langVal }}: </span>
							}
							@case ("medicpatient") {
								<span>{{ "medic" | langVal }}: </span>
							}
						}
						<b>{{ row.diagOrMedic }}</b>
					}

					@if (row.arrived) {
						<div class="card-subtitle d-flex gap-1">
							@if (row.arrived == "yes") {
								<span class="green">✔</span
								><span>{{ "arrived" | langVal }}</span>
							} @else if (row.arrived == "no") {
								<span class="unchecked">✘</span>
								<span>{{ "arrived_no" | langVal }}</span>
							}
						</div>
					}
					@if (
						(permsService?.perms?.clinic_financial ||
							permsService?.perms?.administrative) &&
						row?.price
					) {
						<div class="card-price">
							<span>{{ "price_for_patient" | langVal }}:</span>
							<b> {{ row?.price ? (row.price | finNumber) : "" }} </b>
						</div>
					}

					@if (row.status == "deleted") {
						<div class="card-status mis-auto">
							{{ row.status == "deleted" ? (row.status | langVal) : "" }}
						</div>
					}
					@if (permsService.owner_has_users && row.assoc_names) {
						<div class="w-100">
							<span>{{ "therapists" | langVal }}:</span>
							<span> {{ row.assoc_names }} </span>
						</div>
					}
					@if (row.description && withDescription == "yes") {
						<div
							class="card-content"
							[class.pointer]="row?.type == 'followup' && row.id != followup_id"
						>
							<div class="description-text">
								@switch (row.type) {
									@case ("testfill") {
										@if (row?.test) {
											@if (row?.html_text) {
												<div>
													<span style="font-weight: 700"
														>{{ "test" | langVal }}:
													</span>
													<span
														[innerHTML]="
															highlightSearch(row.html_text) | safeHtml
														"
													></span>
												</div>
											} @else {
												<app-test-display [test]="row.test" />
											}
										}
									}
									@case ("labtestpatient") {
										<!--                   <b>{{ 'recommended' | langVal }}: </b>-->
									}
								}
								@if (row.type !== "testfill") {
									<!-- <h2>{{ "medical_record_title" | langVal }}</h2> -->
									<span
										[innerHTML]="highlightSearch(row.description) | safeHtml"
									></span>
								}
							</div>
						</div>
					}
					@if (withPersonalMemorandum == "yes") {
						@if (row.personal_memorandum) {
							<div
								[innerHTML]="row.personal_memorandum | safeHtml"
								style="white-space: normal"
							></div>
						}
						@if (row.remarks) {
							<div class="w-100">
								<h2>
									<b>{{ "personal_memorandum" | langVal }} </b>
								</h2>
								<span [innerHTML]="row.remarks | safeHtml"></span>
							</div>
						}
					}
					@if (permsService.owner_has_users && withSupervisorNotes == "yes") {
						<div class="w-100">
							<h2>
								<b>{{ "supervisor_notes" | langVal }} </b>
							</h2>
							<span
								[innerHTML]="row.supervisor_notes | safeHtml"
								style="white-space: normal"
							></span>
						</div>
					}
					@if (row?.images?.length) {
						<!-- <div class="w-100"> -->
						<div class="images-container w-100">
							<h2 class="w-100">
								<b>
									{{ "add_image_to_document" | langVal }}
								</b>
							</h2>
							@for (imgObj of row.images; track imgObj) {
								<img
									[src]="imgObj.id | serverImg: 'followup-image'"
									class="fp-image"
									loading="lazy"
									(click)="openGallery(imgObj)"
								/>
							}
						</div>
						<!-- </div> -->
					}
				</div>
				<!-- <tr
					(click)="openRow(row)"
					[class.pointer]="row?.type == 'followup' && row.id != followup_id"
				></tr> -->
			</div>
		}
	</div>
</div>
<div class="panel-options gap-3 w-100 mis-auto">
	<div class="d-flex flex-nowrap gap-1">
		<app-gen-button-group
			optionsListName="mixedList_desc_opts"
			title_ph_lang="followups"
			[actualObj]="this"
			fieldName="withDescription"
		/>

		<app-gen-button-group
			optionsListName="mixedList_pm_opts"
			title_ph_lang="followups"
			[actualObj]="this"
			fieldName="withPersonalMemorandum"
			(changeEvent)="saveCc()"
		/>
		@if (permsService.owner_has_users) {
			<app-gen-button-group
				optionsListName="mixedList_sn_opts"
				title_ph_lang="followups"
				[actualObj]="this"
				fieldName="withSupervisorNotes"
				(changeEvent)="saveCc()"
			/>
		}
	</div>
	<div class="d-flex flex-nowrap">
		<!-- <div class="d-flex no-mob"> -->

		@if (showFutureMeetings == "yes") {
			<!-- <div class="text-end"> -->
			<button
				class="btn btn-primary"
				(click)="modalProps = { name: 'patient-fuses' }"
			>
				{{ "future_meetings" | langVal }}
			</button>
			<!-- </div> -->
		}
		<button
			class="btn btn-primary"
			(click)="print()"
		>
			{{ "print" | langVal }}
		</button>
		<button
			class="btn btn-primary"
			(click)="xlsxDownload()"
		>
			{{ "create_excel" | langVal }}
		</button>
		<app-btn-ext
			text="letter_export"
			[isSpin]="isOpeningDocument"
			(clickEv)="addDocument()"
		/>
	</div>
	<!-- </div> -->

	<!-- <div class="d-flex gap-1 mis-auto pad-btns"> -->
	<!-- </div> -->
</div>
@switch (modalProps?.name) {
	@case ("image-gallery") {
		<app-image-gallery
			(onClose)="modalProps = null"
			[images]="modalProps.images"
			[curImagePosition]="modalProps.curImagePosition"
		/>
	}
	@case ("patient-fuses") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="future_meetings"
			modalWrapperClass="modal-650"
		>
			<app-patient-fuses
				(onClose)="modalProps = null"
				[patient_id]="patient.id"
			/>
		</app-modal-wrap>
	}
	@case ("add-document") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			title="letter"
			modalWrapperClass="modal-800"
		>
			<app-add-document
				(onClose)="modalProps = null"
				[patient_id]="modalProps.patient_id"
				[title]="modalProps.title"
				[preText]="modalProps.preText"
			/>
		</app-modal-wrap>
	}
	@case ("patient") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			[title]="
				patient.name +
				' ' +
				($safeNavigationMigration(modalProps.followup?.date) | dateFormat)
			"
			modalWrapperClass="modal-1200"
		>
			<app-patient
				(onClose)="modalProps = null"
				[patient]="patient"
				[followup]="modalProps.followup"
				[groupAttendRowPatientId]="patient.is_group == 'no' ? patient.id : 0"
				isHomeMeetingOnly
			/>
		</app-modal-wrap>
	}
}
